import { sendHttpRequest } from "../../../components/http.request";
import { validateResponse } from "./../../../components/util";

export const FORM_INITIAL_INFO = {
    documentsAuthorizations: [],
    families: [],
    authorizationList: [],
    processList: [],
    origins: [],
    process: [],
    statusType: [],
    users: [],
    report: {},
};

export async function getReports(requestBody) {
    try {
        const result = await request("gererelatorios", {
            ...requestBody,
            accao: "lista_relatorios",
        });

        if (result) {
            const metadata = result["@attributes"];
            const lista = validateResponse(result);
            return {
                lista,
                metadata: {
                    resultados: Number(metadata.resultados),
                    pagina: Number(metadata.pagina),
                    visivel: metadata.visivel,
                    resultados_pagina: Number(metadata.resultados_pagina),
                },
            };
        }
        return false;
    } catch (error) {
        return false;
    }
}

export async function getReportsInitialData(id) {
    try {
        const formInitialData = await request("gererelatorios", {
            accao: "definicao",
            id: id ? id : -1,
        });
        const usersList = await request("gereutilizador", {
            accao: "utilizadores",
        });

        return {
            documentsAuthorizations: validateResponse(formInitialData.autorizacoes_documento),
            families: validateResponse(formInitialData.familias),
            authorizationList: validateResponse(formInitialData.lista_autorizacoes),
            processList: validateResponse(formInitialData.lista_processos),
            origins: validateResponse(formInitialData.origens),
            process: validateResponse(formInitialData.processos),
            statusType: validateResponse(formInitialData.tipos_estado),
            report: formInitialData.relatorio || {},
            users: validateResponse(usersList),
        };
    } catch (error) {
        return FORM_INITIAL_INFO;
    }
}

export async function getTasks(process) {
    try {
        const result = await request("gereprocesso", {
            accao: "lista_tarefas_nome",
            processo: process,
        });
        return validateResponse(result);
    } catch (error) {
        return [];
    }
}

export async function saveDocument(report) {
    try {
        const file = report.ficheiro;
        if (file) {
            report.ficheiro = {
                name: file.name,
                type: file.type,
            };
        }

        const requestBody = {
            accao: "guardar_definicao",
            dados: JSON.stringify({ controlo_documento: report }),
            ficheiro: file,
            document: report.report,
        };

        if (report.rever) {
            requestBody.rever = report.rever;
        }

        const result = await request("gererelatorios", requestBody);
    } catch (error) {}
}

export async function cancelDocument(id) {
    try {
        const result = await request("gererelatorios", {
            accao: "anular",
            id,
        });
        return validateResponse(result);
    } catch (error) {
        return [];
    }
}

function request(recource, requestBody) {
    const formData = new FormData();
    Object.entries(requestBody).forEach(([key, val]) => {
        formData.append(key, val);
    });

    return sendHttpRequest("POST", `/Gestor/${recource}.php`, formData);
}
